import classNames from 'classnames/bind';
import type { PropsWithChildren } from 'react';

import { Button } from '@/components/shared/buttons';
import { Dropdown } from '@/components/shared/Dropdown';
import type {
  HorizontalPosition,
  VerticalPosition,
} from '@/components/shared/Dropdown/Dropdown';
import { Icon } from '@/components/shared/Icon';

import style from './DropdownLink.module.sass';

const cx = classNames.bind(style);

type DropdownLinkProps = PropsWithChildren<{
  label: string;
  position?: [VerticalPosition, HorizontalPosition];
  width?: 'normal' | 'wide' | 'full';
  className?: string;
}>;

/**
 * Link-looking dropdown trigger: reads as an inline action until it is hovered
 * or opened, when it picks up button chrome. Use it for a secondary action that
 * has to offer a couple of variants without claiming button-level prominence.
 */
export const DropdownLink = ({
  label,
  position = ['bottom', 'center'],
  width = 'normal',
  className,
  children,
}: DropdownLinkProps) => (
  <Dropdown
    position={position}
    width={width}
    popperClassName={style.popper}
    trigger={({ isOpen, toggleIsOpen }) => (
      <Button.Unstyled
        className={cx('trigger', className, { isOpen })}
        onClick={toggleIsOpen}>
        {label}
        <Icon name='ChevronDown' className={style.chevron} />
      </Button.Unstyled>
    )}>
    {children}
  </Dropdown>
);
